import React, {ReactNode, useEffect, useRef, useState} from "react"
import "./styles.css"
import clsx from "clsx";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useAppSelector} from "../../redux/reducer/store";
import {PATH_SCREEN_STRING, PATH_STRINGS} from "../../routes/route-props";
import {useTranslation} from "react-i18next";
import {IconButton, Modal, NumberInput, Text, TextInput} from "atmosfair-ui";
import {useDispatch} from "react-redux";
import {
    addPersonToJourney,
    changeJourneyDescription,
    changeJourneyDuration,
    changeJourneyName,
    removeExactDateFromJourney,
    updateJourneyCustomer
} from "../../redux/reducer/journey";
import {getStringLeftSideColon} from "../../utils/common";
import {MIN_LENGTH_NAME, validTravelComponentsOrJounrneyName} from "../../components/forms/utils";
import {toast, TypeOptions} from "react-toastify";
import ToastWithTextOnly from "../../molecules/toasts/toast-with-text-only/ToastWithTextOnly";
import {JOURNEY_PROPERTIES, VALIDATE_FORM_STARTING_NUMBER} from "../../constants/default-values";
//@ts-ignore
import {de, enGB} from 'react-date-range/dist/locale';
import {isCustomer, isJourneyDatesProps} from "../../utils/check/type-guards";
import DateRangePicker from "../../components/date-range-picker/DateRangePicker";
import {isEqual} from "lodash";
import {DaysRange} from "../../components/activity/hotel/choose-hotel/utils";
import {blockRecalculationFromSiteTitle} from "../../redux/reducer/settings";
import {DatesProps} from "../../types-enums/activity-common-properties";
import {Tooltip} from "@mui/material";
import {
    cleanPathName,
    formatCo2ETotalString,
    formatDateString,
    generateTranslatedActivityTypeString,
    PLACEHOLDER_EMPTY_STRING,
    removeUndefinedFromString
} from "../../utils/string/common";
import {getTotalCo2KgEForActivities, getTotalCo2KgEForJourneyViaSumOfDays} from "../../utils/getter/co2-getter";
import {getDurationInDaysOrNights, getFullName} from "../../utils/getter/common";
import {
    changeTravelComponentsDescription,
    changeTravelComponentsName,
    updateTravelComponentsCustomer
} from "../../redux/reducer/travel-components";
import {Customer} from "../../api/model/customer";
import CustomerForm from "../../components/forms/customer-form/CustomerForm";
import {theme} from "../../styles/theme";
import EmissionsPerTravelOptionTooltip
    from "../../molecules/emissions-per-travel-option-tooltip/EmissionsPerTravelOptionTooltip";
import {ActivityTypeStrings, validActivityTypes} from "../../types-enums/activity";
import {LANGUAGE_ABBREVATION} from "../../locales/locales";
import {ClickAwayListener} from "@mui/base";
import {getActivityPersonCount} from "../../utils/getter/activities";

interface NumberValueProps {
    value: number | null,
    editableInformation?: {
        typeOfValue: 'number',
        ariaErrorMessage: string,
        minValue: number,
        maxValue: number,
        callback: (value: number) => void,
        label: string,
        unit?: string,
    }
}

interface CustomerValueProps {
    value: Customer | null,
    editableInformation?: {
        typeOfValue: 'customer',
        ariaErrorMessage: string,
        callback: (value: string) => void,
        label: string,
    }
}

interface StringValueProps {
    value: string,
    editableInformation?: {
        typeOfValue: 'string',
        ariaErrorMessage: string,
        callback: (value: string) => void,
        label: string,
    }
}

interface StringValueWithTooltipProps {
    value: string,
    tooltip: ReactNode | null,
}

interface JourneyDatesValueProps {
    value: DatesProps | null,
    editableInformation?: {
        typeOfValue: 'journeyDates',
        callback: (value: DatesProps) => void,
        label: string,
        ariaErrorMessage: string,
    }
}

type TextElementsProps =
    NumberValueProps
    | StringValueProps
    | JourneyDatesValueProps
    | CustomerValueProps
    | StringValueWithTooltipProps
    | null
type CombinedValueTypes = NonNullable<TextElementsProps>['value'] | null;

interface LeftRightElementProps {
    title?: string,
    textElements: {
        [key: string]: TextElementsProps
    } | null
}

interface MiddleTextElementEditableInformationProps {
    value: string,
    ariaErrorMessage: string,
    callback: (value: string) => void,
    label: string,
}

interface MiddleElementTextProps {
    title: string,
    editableInformation?: MiddleTextElementEditableInformationProps
}

interface MiddleElementProps {
    main: MiddleElementTextProps,
    subtitle?: MiddleElementTextProps,
}

const {
    minNumberPeople,
    maxNumberPeople,
    minNumberNights,
    maxNumberNights
} = JOURNEY_PROPERTIES

const enum WhichMiddleTextPart {
    main,
    subtitle
}

/**
 * This component displays the title of each site. To determine which title and additional content to display,
 * it uses the url path.
 */
const SiteTitle = () => {
    const {
        personCount,
        journeyDuration,
        activities: journeyActivities,
        name: journeyName,
        description: journeyDescription,
        customer: journeyCustomer
    } = useAppSelector(state => state.journey)
    const {
        activities: travelComponentsActivities,
        name: travelComponentsName,
        description: travelComponentsDescription,
        customer: travelComponentsCustomer
    } = useAppSelector(state => state.travelComponents)
    const {userData, agencies} = useAppSelector(state => state.user)
    const {blockChangeJourneyDuration} = useAppSelector(state => state.settings)
    const {i18n, t} = useTranslation()
    const {resolvedLanguage} = i18n
    const [customerModalVisible, setCustomerModalVisible] = useState(false);
    const [leftElements, setLeftElements] = useState<LeftRightElementProps | null>(null)
    const [rightElements, setRightElements] = useState<LeftRightElementProps | null>(null)
    const [middleElement, setMiddleElement] = useState<MiddleElementProps | null>(null)
    const [middleElementWidth, setMiddleElementWidth] = useState<null | number>(null)
    const [leftElementEditValueIndex, setLeftElementEditValueIndex] = useState<number | null>(null)
    const [rightElementEditValueIndex, setRightElementEditValueIndex] = useState<number | null>(null)
    const [middleTextEdit, setMiddleTextEdit] = useState<WhichMiddleTextPart | null>(null)
    const [validateForm, setValidateForm] = useState(VALIDATE_FORM_STARTING_NUMBER)
    const dispatch = useDispatch()
    const validatorFunction = useRef<(name: string | null | undefined) => boolean>()
    const {activityType, day, screen, id} = useParams()
    const location = useLocation();
    const {pathname} = location
    const navigate = useNavigate()
    const journeyDurationInDays = getDurationInDaysOrNights(journeyDuration, false)
    const cleanedPathName = cleanPathName(pathname)

    useEffect(() => {
        const headerElement = document.getElementsByClassName('site-title-container')
        if (headerElement) {
            const header = headerElement[0]
            const headerWidth = header.clientWidth
            setMiddleElementWidth(headerWidth / 2.5)
        }
    }, [])

    useEffect(() => {
        let activityString = ''
        if (activityType) {
            if (validActivityTypes.includes(activityType as ActivityTypeStrings)) {
                activityString = generateTranslatedActivityTypeString(activityType, i18n);
            } else {
                console.warn(`Invalid Activity: ${activityType}`);
            }
        }
        if (cleanedPathName === PATH_STRINGS.travelComponentsOverview) {
            let totalTravelComponentsEmissions = getTotalCo2KgEForActivities(travelComponentsActivities, true)
            let travelComponentsTitle: string
            let travelComponentsDescriptionString: string

            if (travelComponentsName !== null) {
                travelComponentsTitle = `${t('GENERAL.TRAVEL_COMPONENTS', {interpolation: {escapeValue: false}})}: ${travelComponentsName}`
            } else {
                travelComponentsTitle = t('GENERAL.TRAVEL_COMPONENTS', {interpolation: {escapeValue: false},})
            }

            if (travelComponentsDescription !== null) {
                travelComponentsDescriptionString = `${t('GENERAL.DESCRIPTION', {interpolation: {escapeValue: false}})}: ${travelComponentsDescription}`
            } else {
                travelComponentsDescriptionString = t('GENERAL.ADD_DESCRIPTION', {interpolation: {escapeValue: false}})
            }
            let subtitle: MiddleElementTextProps | undefined
            subtitle = {
                title: travelComponentsDescriptionString,
                editableInformation: {
                    value: travelComponentsDescription === null ? PLACEHOLDER_EMPTY_STRING : travelComponentsDescriptionString.toString(),
                    ariaErrorMessage: "ERRORS.COMMON.NAME",
                    callback: value => dispatch(changeTravelComponentsDescription(value)),
                    label: "GENERAL.DESCRIPTION"
                }
            }
            setMiddleElement({
                ...middleElement?.main,
                main: {
                    title: travelComponentsTitle,
                    editableInformation: {
                        value: travelComponentsName === null ? PLACEHOLDER_EMPTY_STRING : travelComponentsName.toString(),
                        ariaErrorMessage: "ERRORS.COMMON.NAME",
                        callback: value => dispatch(changeTravelComponentsName(value)),
                        label: "GENERAL.TRAVEL_COMPONENT_NAME"
                    }
                },
                subtitle
            })
            const rightElements: LeftRightElementProps["textElements"] = {
                // "GENERAL.CUSTOMER": _setCustomer(travelComponentsCustomer),
                "GENERAL.TOTAL": {
                    value: formatCo2ETotalString(totalTravelComponentsEmissions, resolvedLanguage),
                    tooltip: totalTravelComponentsEmissions === 0 ? null :
                        <EmissionsPerTravelOptionTooltip
                            totalEmissions={totalTravelComponentsEmissions}
                            activities={travelComponentsActivities}/>
                }
            }
            setLeftElements(null)
            setRightElements({textElements: rightElements})
            validatorFunction.current = validTravelComponentsOrJounrneyName
        } else if (cleanedPathName.includes(PATH_STRINGS.addActivityToJourney)) {
            setLeftElements(null)
            setMiddleElement({
                main: {
                    title: t('SCREENS.COMMON.ADD_ACTIVITY_TO_JOURNEY', {
                        activity: activityString,
                        day,
                        interpolation: {escapeValue: false},
                    })
                }
            })
            setRightElements(null)
        } else if (cleanedPathName.includes(PATH_STRINGS.editActivity)) {
            let middleTextString: string = ''
            let additionalString: string = ''
            let activityNotFound = false
            if (resolvedLanguage) {
                const resolvedLanguageEnum = resolvedLanguage as LANGUAGE_ABBREVATION
                switch (resolvedLanguageEnum) {
                    case LANGUAGE_ABBREVATION.de:
                        middleTextString = `${activityString} ${t("GENERAL.EDIT")}`
                        break;
                    case LANGUAGE_ABBREVATION.en:
                        middleTextString = `${t("GENERAL.EDIT")} ${activityString}`
                        break;
                    default:
                        resolvedLanguageEnum satisfies never

                }
            }

            const screenEnumValue = PATH_SCREEN_STRING[screen as keyof typeof PATH_SCREEN_STRING]
            switch (screenEnumValue) {
                case PATH_SCREEN_STRING.tc:
                    additionalString = t('GENERAL.TRAVEL_COMPONENTS')
                    activityNotFound = travelComponentsActivities.filter(activity => activity.common.id === id).length < 1
                    break;
                case PATH_SCREEN_STRING.journey:
                    const activitiesToEdit = journeyActivities.filter(activity => activity.common.id === id)
                    activityNotFound = activitiesToEdit.length < 1
                    const activityToEdit = activitiesToEdit[0]
                    if (activityToEdit) {
                        const {common: {day}} = activityToEdit
                        additionalString = `${t('GENERAL.JOURNEY')} ${t('GENERAL.DAY')} ${day}`
                    }
                    break;
                default:
                    return screenEnumValue satisfies never
            }
            if (activityNotFound) navigate(PATH_STRINGS.travelDatabase)
            setLeftElements(null)
            setMiddleElement({main: {title: `${middleTextString} (${additionalString})`}})
            setRightElements(null)
        } else if (cleanedPathName === PATH_STRINGS.travelDatabase) {
            setLeftElements(null)
            setMiddleElement({
                main: {
                    title: t("SCREENS.HOME.SITE_TITLE", {
                        name: getFullName(userData),
                        interpolation: {escapeValue: false}
                    })
                }
            })
            setRightElements(null)
        } else if (cleanedPathName === PATH_STRINGS.selectTravelComponents) {
            setLeftElements(null)
            setMiddleElement({main: {title: "SCREENS.SELECT_TRAVEL_COMPONENTS.SITE_TITLE"}})
            setRightElements(null)
        } else if (cleanedPathName === PATH_STRINGS.newJourney) {
            setLeftElements(null)
            setMiddleElement({main: {title: "SCREENS.CREATE_JOURNEY.SITE_TITLE"}})
            setRightElements(null)
        } else if (cleanedPathName.includes(`${PATH_STRINGS.addActivityToTravelComponents}`)) {
            setLeftElements(null)
            setMiddleElement({
                main: {
                    title: t('SCREENS.COMMON.ADD_ACTIVITY_TO_TRAVEL_COMPONENTS_TABLE', {
                        activity: activityString,
                        interpolation: {escapeValue: false}
                    })
                }
            })
            setRightElements(null)
        } else if (cleanedPathName === PATH_STRINGS.journey) {
            const totalJourneyEmissions = getTotalCo2KgEForJourneyViaSumOfDays(journeyActivities, journeyDuration, true)
            let journeyTitle: string
            let journeyDescriptionString: string
            let subtitle: MiddleElementTextProps | undefined
            const {dates} = journeyDuration
            const minNumberPeopleForJourney = journeyActivities.length === 0 ? minNumberPeople : Math.min(...journeyActivities.map(getActivityPersonCount).filter((n): n is number => n !== null))
            const leftElements: LeftRightElementProps["textElements"] = {
                "GENERAL.PERSONS": {
                    value: personCount,
                    editableInformation: {
                        typeOfValue: 'number',
                        ariaErrorMessage: t("ERRORS.COMMON.BASE_MIN_MAX_VALUE_EXCEEDED_MESSAGE", {
                            min: minNumberPeopleForJourney,
                            max: maxNumberPeople,
                            words: t("ERRORS.COMMON.MIN_MAX_PEOPLE_EXCEEDED")
                        }),
                        minValue: minNumberPeopleForJourney,
                        maxValue: maxNumberPeople,
                        callback: value => dispatch(addPersonToJourney(value)),
                        label: "LABELS.COMMON.NUMBER_PERSONS",
                    },
                },
                "GENERAL.DURATION": {
                    value: journeyDurationInDays,
                    editableInformation: {
                        typeOfValue: 'number',
                        ariaErrorMessage: t("ERRORS.COMMON.BASE_MIN_MAX_VALUE_EXCEEDED_MESSAGE", {
                            min: minNumberNights,
                            max: maxNumberNights,
                            words: t("ERRORS.COMMON.MIN_MAX_NIGHTS_EXCEEDED")
                        }),
                        minValue: minNumberNights,
                        maxValue: maxNumberNights,
                        callback: value => dispatch(changeJourneyDuration(value)),
                        label: "LABELS.COMMON.NUMBER_NIGHTS",
                        unit: journeyDurationInDays === 1 ? t('GENERAL.DAY') : t('GENERAL.DAYS'),
                    },
                },
                "GENERAL.DATE": {
                    value: dates,
                    editableInformation: {
                        typeOfValue: "journeyDates",
                        callback: () => {
                        },
                        label: "GENERAL.DATE",
                        ariaErrorMessage: "No Error message here to display. Ignore!"
                    }
                }
            }

            const rightElements: LeftRightElementProps["textElements"] = {
                "GENERAL.CUSTOMER": _setCustomer(journeyCustomer),
                "GENERAL.TOTAL": {
                    value: formatCo2ETotalString(totalJourneyEmissions, resolvedLanguage),
                    tooltip: totalJourneyEmissions === 0 ? null :
                        <EmissionsPerTravelOptionTooltip
                            totalEmissions={totalJourneyEmissions}
                            activities={journeyActivities}/>
                }
            }

            if (journeyName !== null) {
                journeyTitle = `${t('GENERAL.JOURNEY')}: ${journeyName}`
            } else {
                journeyTitle = t('GENERAL.JOURNEY')
            }

            if (journeyDescription !== null) {
                journeyDescriptionString = `${t('GENERAL.DESCRIPTION')}: ${journeyDescription}`
            } else {
                journeyDescriptionString = t('GENERAL.ADD_DESCRIPTION')
            }

            if (journeyDurationInDays !== null) {
                setLeftElements({textElements: leftElements})
            } else {
                setLeftElements({textElements: null})
            }
            setRightElements({textElements: rightElements})

            subtitle = {
                title: journeyDescriptionString,
                editableInformation: {
                    value: journeyDescription === null ? PLACEHOLDER_EMPTY_STRING : journeyDescriptionString.toString(),
                    ariaErrorMessage: "ERRORS.COMMON.NAME",
                    callback: value => dispatch(changeJourneyDescription(value)),
                    label: "GENERAL.DESCRIPTION"
                }
            }

            setMiddleElement({
                ...middleElement?.main,
                main: {
                    title: journeyTitle,
                    editableInformation: {
                        value: journeyName === null ? PLACEHOLDER_EMPTY_STRING : journeyName.toString(),
                        ariaErrorMessage: "ERRORS.COMMON.NAME",
                        callback: value => dispatch(changeJourneyName(value)),
                        label: "GENERAL.JOURNEY_NAME"
                    }
                },
                subtitle
            })
            validatorFunction.current = validTravelComponentsOrJounrneyName
        } else if (cleanedPathName === PATH_STRINGS.settings) {
            setLeftElements(null)
            setMiddleElement({main: {title: "SCREENS.SETTINGS.TITLE"}})
            setRightElements(null)
        } else if (cleanedPathName === PATH_STRINGS.help) {
            setLeftElements(null)
            setMiddleElement({main: {title: "SCREENS.HELP.TITLE"}})
            setRightElements(null)
        } else {
            setLeftElements(null)
            setMiddleElement(null)
            setRightElements(null)
        }
    }, [
        userData,
        pathname,
        journeyName,
        journeyDescription,
        travelComponentsName,
        travelComponentsDescription,
        personCount,
        journeyDuration,
        travelComponentsCustomer,
        journeyCustomer,
        agencies,
        journeyActivities,
        travelComponentsActivities
    ])

    const _setCustomer = (customer: Customer | null) => {
        let customerObject: CustomerValueProps | StringValueProps
        if (agencies === null) {
            customerObject = {value: (t("GENERAL.NO_AGENCY"))}
        } else if (agencies.length === 0) {
            customerObject = {value: t("GENERAL.NO_AGENCY")}
        } else {
            customerObject = {
                value: travelComponentsCustomer,
                editableInformation: {
                    typeOfValue: 'customer',
                    ariaErrorMessage: "",
                    callback: () => {
                    },
                    label: "GENERAL.CUSTOMER",
                },

            }
        }
        return customerObject
    }

    const _renderToast = (message: string, type: TypeOptions) => toast(<ToastWithTextOnly
            message={t(message, {interpolation: {escapeValue: false}})}/>,
        {progress: undefined, type}
    )

    const _setDateRange = (dateRange: DaysRange) => {
        const {startDate, endDate} = dateRange
        if (!isEqual(startDate, endDate)) {
            dispatch(changeJourneyDuration(dateRange))
            setLeftElementEditValueIndex(null)
            setRightElementEditValueIndex(null)
            setMiddleTextEdit(null)
        }
    }

    const _setJourneyDatesValue = (dates: CombinedValueTypes) => {
        let conditionalInput = null
        if (isJourneyDatesProps(dates) && journeyDurationInDays !== null) {
            const {startDate, endDate} = dates
            conditionalInput = <>
                <Text
                    classes={'site-title-journey-date'}>{`${t("GENERAL.DATE")}: ${formatDateString(startDate, resolvedLanguage, false)}-${formatDateString(endDate, resolvedLanguage, false)}`}</Text>
                <DateRangePicker
                    nightsDaysCount={journeyDurationInDays}
                    containerStyles={{position: "absolute", top: '100px', left: "70px"}}
                    disabled={blockChangeJourneyDuration}
                    minNumberNightsOrDays={minNumberNights}
                    maxNumberNightsOrDays={maxNumberNights}
                    isNights={false}
                    showOnlyCalendar={true}
                    openCalendarImmediately={true}
                    setDateRange={_setDateRange}
                    dateRange={{startDate, endDate}}
                    setCalendarOpen={value => dispatch(blockRecalculationFromSiteTitle(value))}
                />
            </>
        }
        return conditionalInput
    }

    const _setNumberValue = (valueObject: TextElementsProps) => {
        let conditionalInput = null
        if (valueObject !== null && "editableInformation" in valueObject) {
            const {value, editableInformation} = valueObject
            const inputRef: React.RefObject<HTMLInputElement> = React.createRef()
            if (editableInformation) {
                const {typeOfValue, callback, label, ariaErrorMessage,} = editableInformation
                if (typeOfValue === 'number') {
                    const {
                        minValue,
                        maxValue,
                        unit,
                    } = editableInformation
                    if (typeOfValue === 'number') {
                        let parsedValue: number
                        if (typeof value === 'number') {
                            parsedValue = value
                        } else if (value === null) {
                            parsedValue = 0
                        } else if (typeof value === "string") {
                            parsedValue = parseInt(value, 10)
                        } else {
                            parsedValue = 0
                        }
                        conditionalInput = <>
                            <ClickAwayListener onClickAway={() => {
                                inputRef.current?.blur()
                            }}>
                                <NumberInput
                                    ref={inputRef}
                                    autoFocus={true}
                                    aria-errormessage={ariaErrorMessage}
                                    inputStyle={{padding: 0}}
                                    containerStyle={{maxWidth: '10px'}}
                                    labelInputContainerStyles={{width: "unset", height: "unset"}}
                                    label={label}
                                    min={minValue}
                                    max={maxValue}
                                    injectMinimum={true}
                                    injectMaximum={true}
                                    onBlur={event => {
                                        const {target: {valueAsNumber}} = event
                                        if (valueAsNumber <= maxValue && valueAsNumber >= minValue) {
                                            callback(valueAsNumber)
                                            dispatch(blockRecalculationFromSiteTitle(false))
                                            setLeftElementEditValueIndex(null)
                                            setRightElementEditValueIndex(null)
                                        } else {
                                            if (valueAsNumber > maxValue) {
                                                _renderToast(t("TOASTS.WARNING_MAX_VALUE", {max: maxValue}), "warning")
                                            } else {
                                                _renderToast(t("TOASTS.WARNING_MIN_VALUE", {min: minValue}), "warning")
                                            }
                                        }
                                    }}
                                    onChange={event => {
                                        const {target: {valueAsNumber}} = event
                                        if (valueAsNumber <= maxValue && valueAsNumber >= minValue) {
                                            callback(valueAsNumber)
                                        } else {
                                            if (valueAsNumber > maxValue) {
                                                _renderToast(t("TOASTS.WARNING.GENERIC_MAX", {max: maxValue}), "warning")
                                            } else {
                                                _renderToast(t("TOASTS.WARNING.GENERIC_MIN", {min: minValue}), "warning")
                                            }
                                        }
                                    }}
                                    value={parsedValue}
                                    hideLabel={true}/>
                            </ClickAwayListener>
                            <Text>{unit}</Text>
                        </>
                    }
                }
            }
        }
        return conditionalInput
    }

    const _renderLeftRightFinalText = (text: string, editableInformation: any, withHover: boolean) => <Text
        classes={clsx(editableInformation && withHover && 'site-title-left-right-text-input-wrapper-hover')}>
        {removeUndefinedFromString(text)}
    </Text>

    const _constructLeftRightText = (text: LeftRightElementProps, align: "left" | "right") => {
        const {title, textElements} = text
        return <div className={clsx("site-title-text-wrapper", `site-title-left-right-text-align-${align}`)}>
            {title && <Text>{title}</Text>}
            {textElements !== null && Object.entries(textElements).map(([leftSideOfColon, rightSideOfColonObject], index) => {
                if (rightSideOfColonObject !== null) {
                    const {value} = rightSideOfColonObject
                    if ("editableInformation" in rightSideOfColonObject) {
                        const {editableInformation} = rightSideOfColonObject
                        if (editableInformation) {
                            const {typeOfValue} = editableInformation
                            let conditionalInput = null
                            if (leftElementEditValueIndex !== null && leftElementEditValueIndex === index) {
                                if (typeOfValue === 'number') conditionalInput = _setNumberValue(rightSideOfColonObject)
                                if (typeOfValue === "journeyDates") {
                                    if (journeyDuration.dates !== null) return _setJourneyDatesValue(value) // only god and I know why I can't set conditionalInput = _setJourneyDatesValue(value). If I do, one cannot reselct a date
                                    conditionalInput = _setJourneyDatesValue(value)
                                }
                                if (typeOfValue === 'string') conditionalInput = null
                            }
                            let finalReactNode: React.ReactNode | null
                            const leftSideOfColonTranslated = `${typeof leftSideOfColon === 'string' ? t(leftSideOfColon, {interpolation: {escapeValue: false}}) : leftSideOfColon}`
                            if (conditionalInput !== null) {
                                finalReactNode = _renderLeftRightFinalText(leftSideOfColonTranslated, editableInformation, true)
                            } else {
                                let unit: string | undefined = undefined
                                const {typeOfValue} = editableInformation
                                if (typeOfValue === 'number') unit = editableInformation.unit
                                if (isJourneyDatesProps(value)) {
                                    finalReactNode = _setFinalJourneyDatesNode(value, leftSideOfColonTranslated, editableInformation)
                                } else if (typeOfValue === "customer") {
                                    finalReactNode = _setFinalCustomerNode(value, leftSideOfColonTranslated, editableInformation)
                                } else {
                                    const rightSideOfColon = `${value} ${unit}`
                                    finalReactNode = _renderLeftRightFinalText(`${leftSideOfColonTranslated}: ${rightSideOfColon}`, editableInformation, true)
                                }
                            }
                            if (value === null && typeOfValue === 'journeyDates') return _renderJourneyDates(index, conditionalInput, editableInformation)
                            if (typeOfValue === "customer") return _renderCustomer(index, finalReactNode, value, editableInformation)
                            if (value !== null) return _renderStringOrNumberInput(index, finalReactNode, conditionalInput, editableInformation, typeOfValue === 'journeyDates')
                        } else {
                            return <Text
                                key={index}>{`${t(leftSideOfColon, {interpolation: {escapeValue: false}})}: ${value}`}</Text>
                        }
                    } else {
                        if ("tooltip" in rightSideOfColonObject) {
                            const {tooltip} = rightSideOfColonObject
                            return <Tooltip placement={"top"} key={index} title={tooltip}>
                                <div>
                                    <Text>{`${t(leftSideOfColon, {interpolation: {escapeValue: false}})}: ${value}`}</Text>
                                </div>
                            </Tooltip>
                        } else {
                            return <Text
                                key={index}>{`${t(leftSideOfColon, {interpolation: {escapeValue: false}})}: ${value}`}</Text>
                        }
                    }
                }
            })
            }
        </div>
    }

    const _setFinalCustomerNode = (value: CombinedValueTypes, leftSideOfColonTranslated: string, editableInformation: any) => {
        let rightSideOfColonTranslated = ""
        let finalReactNode: ReactNode
        if (value === null) {
            rightSideOfColonTranslated = t("GENERAL.NO_CUSTOMER")
        } else if (isCustomer(value)) rightSideOfColonTranslated = getFullName(value)!!
        finalReactNode = _renderLeftRightFinalText(`${leftSideOfColonTranslated}: ${rightSideOfColonTranslated}`, editableInformation, true)
        return finalReactNode
    }

    const _setFinalJourneyDatesNode = (value: DatesProps, leftSideOfColonTranslated: string, editableInformation: any) => {
        const {startDate, endDate} = value
        const rightSideOfColon = `${formatDateString(startDate, resolvedLanguage, false)} - ${formatDateString(endDate, resolvedLanguage, false)}`
        return <>
            {_renderLeftRightFinalText(`${leftSideOfColonTranslated}: ${rightSideOfColon}`, editableInformation, !blockChangeJourneyDuration)}
            <IconButton
                disabled={blockChangeJourneyDuration}
                onClick={() => journeyDurationInDays !== null && dispatch(removeExactDateFromJourney())}
                size={'small'}
                tooltip={blockChangeJourneyDuration ? undefined : "TOOLTIP.JOURNEY.REMOVE_EXACT_DATES"}
                icon={"close"}/>
        </>
    }

    const _renderStringOrNumberInput = (
        index: number,
        finalReactNode: ReactNode,
        conditionalInput: ReactNode,
        editableInformation: any,
        hasButtonAsChild: boolean
    ) => {
        let tooltipText: string | null = null
        if (blockChangeJourneyDuration) tooltipText = t('TOOLTIP.JOURNEY.CHANGE_JOURNEY_DURATION_BLOCKED_DELETE_DAY')
        const WrapperTag = hasButtonAsChild ? "div" : "button"
        const Node = <WrapperTag
            onClick={() => {
                if (!blockChangeJourneyDuration && leftElementEditValueIndex === null) {
                    setMiddleTextEdit(null)
                    setRightElementEditValueIndex(null)
                    if (editableInformation) {
                        if (leftElementEditValueIndex === null) {
                            dispatch(blockRecalculationFromSiteTitle(true))
                            setLeftElementEditValueIndex(index)
                        } else {
                            if (typeof leftElementEditValueIndex === "number") setLeftElementEditValueIndex(null)
                        }
                    }
                }
            }}
            style={{position: "relative"}}
            key={index}
            className="site-title-left-right-text-input-wrapper">
            {finalReactNode}
            {conditionalInput}
        </WrapperTag>

        if (tooltipText !== null) return <Tooltip placement={"top"} key={index} title={tooltipText}>{Node}</Tooltip>
        return Node
    };

    const _renderJourneyDates = (index: number, conditionalInput: ReactNode, editableInformation: any) => {
        if (journeyDurationInDays !== null) return <div
            onClick={() => {
                setMiddleTextEdit(null)
                setRightElementEditValueIndex(null)
                setLeftElementEditValueIndex(null)
            }}
            style={{position: 'relative'}}
            key={index}
            className={clsx(
                'site-title-left-right-text-input-wrapper',
                "site-title-date-ranger-picker",
            )}>
            <Text
                classes={clsx(editableInformation && !blockChangeJourneyDuration && 'site-title-left-right-text-input-wrapper-hover')}>
                {t('GENERAL.DATE')}
            </Text>
            <DateRangePicker
                containerClasses={"site-title-date-ranger-picker-container"}
                disabled={blockChangeJourneyDuration}
                setDateRange={_setDateRange}
                minNumberNightsOrDays={minNumberNights}
                maxNumberNightsOrDays={maxNumberNights}
                isNights={false}
                nightsDaysCount={journeyDurationInDays}
                setCalendarOpen={value => dispatch(blockRecalculationFromSiteTitle(value))}
                showOnlyCalendarIcon={true}/>
            {conditionalInput}
        </div>
    }

    const _onCloseCustomerModal = () => {
        setCustomerModalVisible(false)
        setRightElementEditValueIndex(null)
        setValidateForm(VALIDATE_FORM_STARTING_NUMBER)
    }

    const _renderCustomer = (index: number, finalReactNode: ReactNode, value: CombinedValueTypes, editableInformation: any) =>
        <div key={index}
             className={"site-title-customer-icon-wrapper"}>
            <button
                style={{padding: 0}}
                onClick={() => {
                    if (editableInformation && rightElementEditValueIndex === null) {
                        setCustomerModalVisible(true)
                        setRightElementEditValueIndex(index)
                        setMiddleTextEdit(null)
                        setLeftElementEditValueIndex(null)
                    }

                }}>
                {finalReactNode}
            </button>
            {value !== null && <IconButton
                onClick={() => pathname.includes("journey") ? dispatch(updateJourneyCustomer(null)) : dispatch(updateTravelComponentsCustomer(null))}
                icon={"trash"}
                tooltip={"TOOLTIP.SITE_TITLE.DELETE_CUSTOMER"}
                size={"small"}/>}
            <Modal
                closeButtonText={"GENERAL.ABORT"}
                confirmButtonText={"GENERAL.OK"}
                onEnterKeyPressed={() => setValidateForm(validateForm + 1)}
                onConfirm={() => setValidateForm(validateForm + 1)}
                onClose={() => _onCloseCustomerModal()}
                showPaper={true}
                headline={value === null ? "MODALS.CUSTOMER.CREATE_CUSTOMER_TITLE" : "MODALS.CUSTOMER.EDIT_CUSTOMER_TITLE"}
                onBackdropClick={() => {
                    setRightElementEditValueIndex(null)
                    setCustomerModalVisible(false)
                }}
                show={customerModalVisible}>
                {value !== null &&
                    <Text
                        style={{marginBottom: theme.spacer.large}}>MODALS.CUSTOMER.EDIT_CUSTOMER_TEXT</Text>}
                {agencies && <CustomerForm
                    defaultCustomer={pathname.includes("journey") ? journeyCustomer : travelComponentsCustomer}
                    agencies={agencies}
                    validateForm={validateForm}
                    showCompany={false}
                    onFormIsValid={customer => {
                        pathname.includes("journey") ? dispatch(updateJourneyCustomer(customer)) : dispatch(updateTravelComponentsCustomer(customer))
                        _onCloseCustomerModal()
                    }}
                    hideAgencySelection={false}
                />}
            </Modal>
        </div>

    const _setMiddleTextInputElement = (
        editableInformation: MiddleTextElementEditableInformationProps,
        title: string,
        whichPart: WhichMiddleTextPart
    ) => {
        const {value, ariaErrorMessage, callback, label} = editableInformation
        const inputRef: React.RefObject<HTMLInputElement> = React.createRef()
        return <ClickAwayListener onClickAway={() => inputRef.current?.blur()}>
            <div
                className={"site-title-middle-text-input-wrapper"}>
                <Text
                    style={{flex: 1}}
                    variant={whichPart === WhichMiddleTextPart.main ? "headlineLarge" : 'body'}>
                    {`${getStringLeftSideColon(title)}: `}
                </Text>
                <TextInput
                    ref={inputRef}
                    autoFocus={true}
                    aria-errormessage={ariaErrorMessage}
                    containerStyle={{width: '100%'}}
                    inputClasses={clsx(whichPart === WhichMiddleTextPart.main && 'site-title-middle-text-headline-input')}
                    inputStyle={{padding: 0}}
                    onBlur={event => {
                        const newNameTrimmed = event.target.value.trim()
                        if (newNameTrimmed.length === 0) {
                            if (whichPart === WhichMiddleTextPart.main) {
                                if (validatorFunction.current?.(newNameTrimmed)) callback(newNameTrimmed)
                            } else {
                                callback(newNameTrimmed)
                            }
                            setMiddleTextEdit(null)
                        } else if (validatorFunction.current?.(newNameTrimmed)) {
                            callback(newNameTrimmed)
                            setMiddleTextEdit(null)
                        } else {
                            _renderToast(t("TOASTS.WARNING.NAME_TO_SHORT", {min: MIN_LENGTH_NAME}), "warning")
                        }
                    }}
                    label={label}
                    placeholder={` ${value}`}
                    hideLabel={true}/>
            </div>
        </ClickAwayListener>
    }

    const _constructMiddleText = (middleText: MiddleElementProps['main'] | undefined, whichPart: WhichMiddleTextPart) => {
        if (middleText) {
            let conditionalMainInput: React.ReactNode | null = null
            const {editableInformation, title} = middleText
            const noTravelComponentsTitle = cleanedPathName === PATH_STRINGS.travelComponentsOverview && travelComponentsName === null && whichPart === WhichMiddleTextPart.main
            if (editableInformation && middleTextEdit === whichPart) conditionalMainInput = _setMiddleTextInputElement(editableInformation, title, whichPart)
            return (editableInformation && middleTextEdit === whichPart) ? conditionalMainInput :
                <button
                    className={"site-title-middle-text-input-wrapper"}><Text
                    classes={clsx(
                        editableInformation && 'site-title-middle-text-input-wrapper-hover',
                        'site-title-middle-text-headline')
                    }
                    variant={whichPart === WhichMiddleTextPart.main ? "headlineLarge" : 'body'}
                    onClick={() => {
                        setLeftElementEditValueIndex(null)
                        setRightElementEditValueIndex(null)
                        dispatch(blockRecalculationFromSiteTitle(false))
                        setMiddleTextEdit(middleTextEdit === null ? whichPart : null)
                    }}>
                    {noTravelComponentsTitle ? `${title}: ` : title}
                </Text>
                    {noTravelComponentsTitle && <Text
                        classes={"site-title-middle-text-input-wrapper-hover"}
                        onClick={() => {
                            setLeftElementEditValueIndex(null)
                            setRightElementEditValueIndex(null)
                            dispatch(blockRecalculationFromSiteTitle(false))
                            setMiddleTextEdit(middleTextEdit === null ? whichPart : null)
                        }}
                        color={"lightGreyDarker"}
                        variant={whichPart === WhichMiddleTextPart.main ? "headlineLarge" : 'body'}>...</Text>}
                </button>
        }
    }

    const _renderMiddleText = (middleText: MiddleElementProps) => {
        const {main, subtitle} = middleText
        return <div
            className={clsx("site-title-text-wrapper", "site-title-middle-text")}>
            {_constructMiddleText(main, WhichMiddleTextPart.main)}
            {_constructMiddleText(subtitle, WhichMiddleTextPart.subtitle)}
        </div>

    }

    const _setMiddleElementStyle = () => {
        if (cleanedPathName === PATH_STRINGS.journey && middleElementWidth !== null) return {width: middleElementWidth}
        return {}
    }

    return <header className={"site-title-container"}>
        {leftElements && _constructLeftRightText(leftElements, "left")}
        {middleElement && <div
            style={_setMiddleElementStyle()}
            className={"site-title-title"}>{_renderMiddleText(middleElement)}</div>}
        {rightElements && _constructLeftRightText(rightElements, "right")}
    </header>
}

export default SiteTitle